import orderUtil from "../../Utils/orderUtil.js";
const Css = {
  PlayLine(marginLeft, showOrHide){
    return {
      display: showOrHide,
      position: "absolute",
      marginTop: "18px",
      marginLeft: marginLeft + "px",
      cursor: "pointer",
      userSelect: "none",
      overflow: "hidden",
      height: orderUtil.controlBoxHeight - 18 + "px"
    }
  },
  PlayLineImg:{
    
  }
}

export default Css;